export enum EComponentItemTableColumnKeys {
  TITLE = 'title',
  PARTNER = 'partner',
  MODIFIED_TIMESTAMP = 'lastEditedTimestamp',
  ACTIONS = 'actions',
}

export const COLUMNS_COMPONENT_ITEMS = [
  {
    id: EComponentItemTableColumnKeys.TITLE,
    headerName: 'Title',
    sortable: false,
  },
  {
    id: EComponentItemTableColumnKeys.PARTNER,
    headerName: 'Owner',
    sortable: false,
  },
  {
    id: EComponentItemTableColumnKeys.MODIFIED_TIMESTAMP,
    headerName: 'Last edited',
    sortable: false,
  },
  {
    id: EComponentItemTableColumnKeys.ACTIONS,
    headerName: 'Actions',
    sortable: false,
  },
];

export enum ECOMPONENT_CHAIN_COLUMN_IDS {
  SELECTION = 'selection',
  TITLE = 'title',
  OWNER = 'owner',
  INVOLVED_PARTNERS = 'involvedPartners',
  ACTIONS = 'actions',
}

export const COLUMNS_COMPONENT_CHAINS = [
  {
    id: ECOMPONENT_CHAIN_COLUMN_IDS.SELECTION,
    headerName: '',
    sortable: false,
  },
  {
    id: ECOMPONENT_CHAIN_COLUMN_IDS.TITLE,
    headerName: 'Title',
    sortable: false,
  },
  {
    id: ECOMPONENT_CHAIN_COLUMN_IDS.OWNER,
    headerName: 'Owner',
    sortable: false,
  },
  {
    id: ECOMPONENT_CHAIN_COLUMN_IDS.INVOLVED_PARTNERS,
    headerName: 'Involved partners',
    sortable: false,
  },
  {
    id: ECOMPONENT_CHAIN_COLUMN_IDS.ACTIONS,
    headerName: 'Actions',
    sortable: false,
  },
];
